import { z } from 'zod'

export const MEMBERSHIP_GRANTS_WRITE_CONTRACT_VERSION = '1.0.1' as const
const numericString = z.string().regex(/^[0-9]+$/)
const productKey = z.string().regex(/^[a-z][a-z0-9_-]{0,63}$/)

export const membershipGrantCreateRequestSchema = z.object({
  orgId: z.string(),
  userId: z.string(),
  roleDefinitionId: z.string(),
}).passthrough()

export const membershipGrantRevokeRequestSchema = z.object({}).passthrough()

export const membershipGrantCreateResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_GRANTS_WRITE_CONTRACT_VERSION),
  grantId: numericString,
  userId: numericString,
  orgId: numericString,
  product: productKey,
  roleDefinitionId: numericString,
  grantVersion: z.number().int().nonnegative(),
}).passthrough()

export const membershipGrantRevokeResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_GRANTS_WRITE_CONTRACT_VERSION),
  revoked: z.boolean(),
  grantId: numericString,
  grantVersion: z.number().int().nonnegative(),
}).passthrough()

export type MembershipGrantCreateRequest = z.infer<typeof membershipGrantCreateRequestSchema>
export type MembershipGrantRevokeRequest = z.infer<typeof membershipGrantRevokeRequestSchema>
export type MembershipGrantCreateResponse = z.infer<typeof membershipGrantCreateResponseSchema>
export type MembershipGrantRevokeResponse = z.infer<typeof membershipGrantRevokeResponseSchema>
